<template>
  <div>
    <kst-output field="Name" :data="details" :catalog="Catalog"/>
    <kst-output field="DiscPercent" :data="details" :catalog="Catalog"/>
    <kst-output field="IsActive" :data="details" :catalog="Catalog"/>
    <kst-output field="Comment" :data="details" :catalog="Catalog"/>
    <kst-created :data="details"/>
    <kst-last-updated :data="details"/>
  </div>
</template>

<script>
import Catalog from "../SpCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>